import { useEffect, useState } from 'react';
export function useLocalStorage(key, initialValue, defaultValue) {
  const [value, setValue] = useState(initialValue);
  useEffect(() => {
    const stored = localStorage.getItem(key);
    if (stored) setValue(stored);else setValue(defaultValue);
  }, [defaultValue, initialValue, key]);
  return [value, setValue];
}